import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "about" */ '../views/index.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/about-company.vue')
  },
  {
    path: '/business',
    name: 'business',
    component: () => import(/* webpackChunkName: "about" */ '../views/business-layout.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import(/* webpackChunkName: "about" */ '../views/product-center.vue')
  },
  {
    path: '/news-information',
    name: 'news-information',
    component: () => import(/* webpackChunkName: "about" */ '../views/news-information.vue')
  },
  {
    path: '/news-information/news-detail',
    name: 'news-detail',
    component: () => import(/* webpackChunkName: "about" */ '../views/news-detail.vue')
  },
  {
    path: '/recruitment',
    name: 'recruitment',
    component: () => import(/* webpackChunkName: "about" */ '../views/talent-recruitment.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "about" */ '../views/contact-us.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
